import { useCallback } from 'react';

import { useWatchlists } from 'hooks/watchlist/useWatchlists';

import { useAddToWatchlist } from './useAddToWatchlist';

export const useCreateAndAddToWatchlist = () => {
  const { upsertWatchlist } = useWatchlists();
  const { addToWatchlist } = useAddToWatchlist();

  const createAndAddToWatchlist = useCallback(
    async (title: string, printablePlayerIds: string[]) => {
      const createWatchlist = await upsertWatchlist.mutate({ title });
      const watchlistId = createWatchlist?.data?.upsertWatchlist?.watchlist?.id;
      if (watchlistId) {
        await addToWatchlist.mutate(watchlistId, printablePlayerIds);
      }
      return createWatchlist;
    },
    [upsertWatchlist, addToWatchlist]
  );

  const createAndAddToWatchlistLoading =
    upsertWatchlist.loading || addToWatchlist.loading;

  return {
    createAndAddToWatchlist: {
      mutate: createAndAddToWatchlist,
      loading: createAndAddToWatchlistLoading,
    },
  };
};
